<template>
  <div>
    <HazardReportToolbar
      :report="report"
      :error="error"
      :filters="filters"
      :allow-single-mode="allowSingleMode"
      :single-mode="singleMode"
      :show-images="showImages"
      :profiles="profiles"
      :hierarchy="getHazardCategoriesHierarchy"
      :checked-structures="getCheckedStructures"
      :downloading="downloading"
      :export-items="hazardExportItems"
      :selected-structures="selectedStructures"
      :records-for-transfer="recordsForTransfer"
      :hazard-url="HAZARD_URL"
      :default-v-tooltip-props="defaultVTooltipProps"
      toolbar-class="fixed-bar"
      show-back-button
      @back="onBack"
      @update:filters="filters = $event"
      @update:singleMode="singleMode = $event"
      @update:showImages="showImages = $event"
      @update:downloading="downloading = $event"
      @select-all="onSelectAllStructures"
      @clear-selection="onClearSelection"
      @report-saved="onReportSaved"
      @report-updated="onReportUpdated"
      @acl-updated="onAclUpdated"
      @reset="onReset"
    />

    <HazardReportBody
      :downloading="downloading"
      :filtered-report="filteredReport"
      :single-mode="singleMode"
      :filters="filters"
      :show-images="showImages"
      :selected-structures="selectedStructures"
      :chem-id="chemId"
      :on-check-click="onStructureCheckboxClick"
      @onFilterAdded="onFilterSelection"
      @showUnlikely-changed="updateShowUnlikely"
    />
  </div>
</template>

<script>
import HazardReportBody from '@/components/hazard/HazardReportBody.vue'
import HazardReportState from '@/components/hazard/HazardReportState'
import HazardReportToolbar from '@/components/hazard/HazardReportToolbar.vue'

export default {
  mixins: [HazardReportState],

  components: {
    HazardReportBody,
    HazardReportToolbar,
  },

  methods: {
    onBack() {
      this.$router.push('/hazard')
    },
  },
}
</script>
